import React from 'react';

import { Skeleton } from '../../../Skeleton';

/**
 * Скелетон кнопки сортировки комментов
 */
export const SortButtonSkeleton = () => <Skeleton width={160} height={28} />;
